import React from 'react'

import { emptyCharacter } from '../../../components/EmptyChar'
import { Summary, SummaryCounters } from '../../../components/Summary/Summary'
import { momentDateHandler } from '../../../date/moment-date-handler'
import { formatCurrency } from '../../../formatters'
import { Trade } from '../models'

const { sortByDate, newDate, formatDate } = momentDateHandler

const sumTradesPrincipal = (trades: Trade[]) => trades.reduce((sum: number, trade) => sum + trade.principal, 0)

const sumTradesAccrued = (trades: Trade[]) =>
  trades.reduce((sum: number, trade) => sum + trade.interests.current.accrued, 0)

const getNextMaturityTrade = (trades: Trade[]) => {
  const [nextTradeMaturing] = trades
    .filter((trade) => trade.instrumentCode !== 'CASH')
    .sort((firstTrade, secondTrade) =>
      sortByDate({ firstDate: newDate(firstTrade.maturityDate), secondDate: newDate(secondTrade.maturityDate) }),
    )

  if (!nextTradeMaturing) return emptyCharacter

  return `${formatDate({ date: newDate(nextTradeMaturing.maturityDate) })} (${nextTradeMaturing.id})`
}

const calculateSummaryItems = (trades: Trade[]): SummaryCounters => ({
  trades: { title: 'Trades', value: trades.length },
  amount: {
    title: 'Amount $',
    value: formatCurrency({ value: sumTradesPrincipal(trades), notation: 'compact', maximumPrecision: 3 }),
  },
  accrued: {
    title: 'Accrued $',
    value: formatCurrency({ value: sumTradesAccrued(trades), notation: 'compact', maximumPrecision: 3 }),
  },
  nextMaturity: { title: 'Next Maturity', value: getNextMaturityTrade(trades) },
})

interface Props {
  isLoading: boolean
  trades: Trade[]
}

export const TradesSummary = ({ trades = [], isLoading }: Props) => (
  <Summary items={trades} calculateSummaryItemsFunction={calculateSummaryItems} isLoading={isLoading} />
)
